import {RootElement} from '@genestack/ui';
import React from 'react';
import {Query, QueryCache, QueryClient, QueryClientProvider} from '@tanstack/react-query';

import styles from './application.module.css';
import {GlobalErrorBoundary} from './components/error-boundary';
import {Routes} from './routes';
import {CallApiResult} from './utils/api-client/parse-fetch-response';
import {showErrorNotification} from './providers/notifications-center/show-notification';

const onQueryErr = (err: unknown, query: Query<unknown, unknown, unknown, readonly unknown[]>) => {
    if ((err as CallApiResult).response && (err as CallApiResult).response.status === 401) {
        return;
    }

    if (query.meta && query.meta.ignoreError) {
        return;
    }

    showErrorNotification('Request error, try again later')(err);
};

const onMutationErr = (err: unknown) => {
    if ((err as CallApiResult).response && (err as CallApiResult).response.status === 401) {
        return;
    }

    showErrorNotification('Request error, try again later')(err);
};

const queryCache = new QueryCache({
    onError: onQueryErr
});

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: false,
            staleTime: Infinity,
            throwOnError: false
        },
        mutations: {
            throwOnError: false,
            onError: onMutationErr
        }
    },
    queryCache
});

export const Application = function ApplicationComponent() {
    return (
        <RootElement className={styles.root}>
            <QueryClientProvider client={queryClient}>
                <GlobalErrorBoundary>
                    <Routes />
                </GlobalErrorBoundary>
            </QueryClientProvider>
        </RootElement>
    );
};
